import { ProbabilitiesTable } from "../Inspect/ProbabilitiesTable";
import { FeatureAnchor, SampleAnchor } from "../PaperShared/Sample";

function PatchingTopics() {
  const adjectivePredictions = {
    " desirable": 0.09742705523967743,
    " natural": 0.08330953121185303,
    " suitable": 0.05190848931670189,
  };
  const nounPredictions = {
    " wildlife": 0.12808816134929657,
    " vegetation": 0.11828392744064331,
    " forest": 0.05285985767841339,
  };

  return (
    <section className="sample">
      <h4>Patching Topics</h4>
      <p>
        <FeatureAnchor modelId="mini" sampleId="1110000-P1" featureKey="0.7.4195" /> responses to
        phrases focused on ecology and can be patched into a circuit to generate words from various
        parts of speech, depending on context. In{" "}
        <SampleAnchor modelId="mini" sampleId="1110000-P1" text="Sample 1110000" />, the circuit
        predicts adjectives describing the characteristics of wildlife habitats. In{" "}
        <SampleAnchor modelId="mini" sampleId="2032000-P1" text="Sample 2032000" />, it generates
        nouns that name different types of environments.
      </p>
      <div className="figures">
        <figure>
          <figcaption>
            Predictions for{" "}
            <SampleAnchor modelId="mini" sampleId="1110000-P1" text="Sample 1110000" />
          </figcaption>
          <ProbabilitiesTable probabilities={adjectivePredictions} limit={3} />
          <p className="description">
            Most likely tokens after patching in{" "}
            <FeatureAnchor modelId="mini" sampleId="1110000-P1" featureKey="0.7.4195" /> to predict
            adjectives related to ecology
          </p>
        </figure>
        <figure>
          <figcaption>
            Predictions for{" "}
            <SampleAnchor modelId="mini" sampleId="2032000-P1" text="Sample 2032000" />
          </figcaption>
          <ProbabilitiesTable probabilities={nounPredictions} limit={3} />
          <p className="description">
            Most likely tokens after patching in{" "}
            <FeatureAnchor modelId="mini" sampleId="2032000-P1" featureKey="0.7.4195" /> to predict
            nouns related to ecology
          </p>
        </figure>
      </div>
    </section>
  );
}

export { PatchingTopics };
